import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedItemMaquilarComponent {
  calculando = false
  colaboradores = []
  configuracion = []
  error = ''
  maquilando
  nomina = {}
  solicitudId
  viaticoId
  onClose

  constructor ($log, NominaCalculoFactory, ViaticosConfiguracionService, ViaticosMaquilarService) {
    this.$log = $log
    this.NominaCalculoFactory = NominaCalculoFactory
    this.ViaticosConfiguracionService = ViaticosConfiguracionService
    this.ViaticosMaquilarService = ViaticosMaquilarService
  }

  $onInit () {
  }

  $onDestroy () {
    this.terminar()
  }

  aceptar () {
    this.ViaticosConfiguracionService.get(this.solicitudId, this.viaticoId)
      .then(({data}) => {
        this.maquilando = false
        this.calculando = true
        this.colaboradores = data.colaboradores
        this.configuracion = data.configuracion
        this.viaticoCalculo = this.NominaCalculoFactory(this.colaboradores, this.configuracion)
        this.viaticoCalculo.onError = (error) => (this.onError(error))
        this.viaticoCalculo.onComplete = () => (this.onComplete())
        this.viaticoCalculo.iniciar()
      })
      .catch(({data}) => (this.error = data))
  }

  cancelar () {
    this.terminar()
    this.cerrar()
  }

  cerrar () {
    let detail = {
      resultado: (this.viaticoCalculo && this.viaticoCalculo.resultado) || null,
      error: (this.viaticoCalculo && this.viaticoCalculo.error) || null,
      completado: (this.viaticoCalculo && this.viaticoCalculo.completado) || false,
      configuracion: this.configuracion,
    }

    this.ViaticosMaquilarService.post(this.solicitudId, this.viaticoId, detail)
      .then(({data}) => {
        this.nomina = data
        this.calculando = false
        this.calculado = true
      })
  }

  finalizar (redireccionar = false) {
    this.onClose({$event: {detail: {nomina: this.nomina, redireccionar: redireccionar}}})
  }

  onError (error) {
    this.$log.error(error)
    this.terminar()
  }

  onComplete () {
    this.terminar()
    this.cerrar()
  }

  terminar () {
    if (this.viaticoCalculo) {
      this.viaticoCalculo.cancelar()
    }
  }
}

module.component('viaticosSharedItemMaquilar', {
  controller: ViaticosSharedItemMaquilarComponent,
  template,
  bindings: {
    maquilando: '<',
    solicitudId: '<',
    viaticoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/item/maquilar/component.js